<template>
  <div data-cy="time-display" class="text-label">{{ formattedTime }}</div>
</template>
<script setup lang="ts">
import { useInterval } from "@vueuse/core";
import { computed } from "vue";

const { counter: secondsElapsed } = useInterval(1_000, { controls: true });

const formattedTime = computed(() =>
  new Date(secondsElapsed.value * 1_000).toISOString().slice(14, 19)
);
</script>
